import { marked } from "marked";

/**
 * Converts a markdown string into clean HTML compatible with ReactQuill / WYSIWYG editors.
 * If the string is already HTML and doesn't contain unformatted markdown, returns it untouched.
 */
export function markdownToHtml(value: string | undefined | null): string {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';

  const normalized = value.replace(/\\r\\n/g, '\n').replace(/\\n/g, '\n');
  const hasHtmlTags = /<\/?(?:p|h[1-6]|ul|ol|li|blockquote|div|span|strong|b|em|i|table|a)[\s>]/i.test(normalized);

  if (hasHtmlTags && !/(?:^|\n)\s*(?:#{1,6}\s+|[-*+]\s+)/.test(normalized)) {
    return normalized;
  }

  try {
    const html = marked.parse(normalized, { async: false }) as string;
    return html.trim();
  } catch (err) {
    console.error('Error parsing markdown to HTML:', err);
    return normalized;
  }
}
